import { render } from "./AddPage.vue?vue&type=template&id=88725c74&scoped=true"
import script from "./AddPage.vue?vue&type=script&lang=js"
export * from "./AddPage.vue?vue&type=script&lang=js"

import "./AddPage.vue?vue&type=style&index=0&id=88725c74&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88725c74"]])

export default __exports__